import React, { useEffect, useState } from "react";
import classes from "./DocumentContent.module.scss";
import IframeLoader from "../ViewContentLoading/IframeLoader";

const DocumentContent = ({ shotclassData }) => {
  const [updatedSrc, setUpdatedSrc] = useState("");
  const [isIFrameLoaded, setIsIFrameLoaded] = useState(true);

  useEffect(() => {
    if (shotclassData) {
      if (shotclassData?.Mediatype === 3) {
        let splittedSrc = shotclassData?.VideoUrl.split("src=");
        let encodedSrc = encodeURIComponent(splittedSrc[1]);
        setUpdatedSrc(splittedSrc[0] + "src=" + encodedSrc);
        //   } else if (shotclassData?.Mediatype === 7) {
        //     let encodedSrc = encodeURIComponent(shotclassData?.VideoUrl);
        //     setUpdatedSrc(encodedSrc);
      } else {
        setUpdatedSrc(shotclassData?.VideoUrl);
      }
    }
  }, [shotclassData]);

  useEffect(() => {
    setIsIFrameLoaded(true); // Show loader initially
  }, [updatedSrc]);

  const handleIframeLoad = () => {
    setIsIFrameLoaded(false); // Hide loader when iframe content is fully loaded
  };

  return (
    <div className={classes.documentContent}>
      {isIFrameLoaded && <IframeLoader isIFrameLoaded={isIFrameLoaded} />}
      <iframe
        id="iframeInDocument"
        className={`${classes.documentContent__iframeplayer} ${
          isIFrameLoaded ? classes.hiddenIframe : ""
        }`}
        allowFullScreen
        src={updatedSrc}
        title={shotclassData?.Name}
        onLoad={handleIframeLoad}
      />
    </div>
  );
};

export default DocumentContent;
